<div
    class="cipo--width--full"
    data-testid="assignments-skeleton"
    role="status"
    [attr.aria-busy]="true"
    [attr.aria-label]="'a11y.assignments.loading' | translate">
    <div class="cipo--border--lite cipo--border-radius--xs cipo--overflow--hidden">
        @for (row of rows; track $index; let last = $last) {
            <div
                fxLayout
                fxLayoutGap="24px"
                fxLayoutAlign="space-between center"
                class="p-y-sm p-x"
                [class.cipo--border-bottom--lite]="!last">
                <div [fxFlex]="detailsPercent()" fxLayout="column" fxLayoutGap="6px">
                    <ngx-skeleton-loader [theme]="row.name" />
                    <ngx-skeleton-loader [theme]="row.org" />
                    <ngx-skeleton-loader [theme]="row.roles" />
                </div>

                @if (showRate()) {
                    <span fxFlex="none"><ngx-skeleton-loader [theme]="theme.field" /></span>
                }
                @if (showAllocation()) {
                    <span fxFlex="none"><ngx-skeleton-loader [theme]="theme.field" /></span>
                }

                <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
                    <span fxFlex="0 0 32px"></span>
                    <span fxFlex><ngx-skeleton-loader [theme]="theme.select" /></span>
                    <ngx-skeleton-loader appearance="circle" [theme]="theme.icon" />
                </div>
            </div>
        }
    </div>
</div>
